import { gql } from 'graphql-tag';

export const GET_SUPPLIERS = gql`
  query Id0faa40e6606a9907a16839675c9be3ea($companyId: ID!) {
    __typename
  }
`;
